import { ErrorHandler, Injectable } from '@angular/core';

import { PrismeLoggerService } from '@services/prisme-logger.service';

@Injectable({
    providedIn: 'root',
})
export class PrismeErrorService implements ErrorHandler {
    public constructor(private _prismeLogService: PrismeLoggerService) {}

    handleError(error: Error): void {
        // TODO: Find why error is trigger many times before uncomment code
        console.log(error);
        //  this._prismeLogService.sendLogToPrisme('Erreur Angular', error);
    }
}
